import { Link } from 'react-router-dom';
import { Button } from '../components/primitives';
import styles from './Placeholder.module.css';

export function NotFound() {
  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.eyebrow}>404</div>
        <h1 className={styles.title}>Stránka neexistuje</h1>
      </div>
      <div>
        <Link to="/">
          <Button variant="primary">Zpět na rozcestník</Button>
        </Link>
      </div>
    </div>
  );
}
